<div class="property-item mx-1" (click)="onClick()">
  @let p=property()!;
  <mat-card appearance="outlined" [ngClass]="[(viewType()=='list') ? 'mat-card-row' : 'mat-card-column']" >
    <mat-card-content>
      <div [ngClass]="[(viewType()=='list') ? 'w-40' : 'w-100']" >
        @if (isProperty(p) && p.auction && p.auction.auctionStatus<=3) {
          <div class="property-status" [ngClass]="[(viewType()=='list') ? 'w-40' : 'w-100']">
            @for (status of p.status; track status) {
              <span [style.background-color]="getStatusBgColor(status)" class="px-1 mx-1">{{status}}</span>
            }
          </div>
        }
        <a class="property-image w-100">
          @if (p.propertyImageArray && p.propertyImageArray.length > 0) {
            <app-listing-image [src]="p.propertyImageArray[0].reference" [frame]="p.propertyImageArray[0].frame" [fit]="p.propertyImageArray[0].fit"></app-listing-image>
          }
          @else {
            <img src="assets/images/others/no_image.jpg">
          }
        </a>
      </div>
      <div [ngClass]="[(viewType()=='list') ? 'w-60 ml-4' : 'w-100']" class="description">
        <div class="description-content">
          <div class="title">
            <div class="pr-1">{{p.formattedAddress1}}</div>
            <div>{{p.formattedAddress2}}</div>
          </div>
          @if (viewType()=='list' && fullWidthPage()) {
            <div class="show-gt-sm mt-3">
              <p>{{p.description}}</p>
            </div>
          }
          <div class="property-features my-2">
            <div class="flex-row space-between items-center property-type"><span>{{p.type?.name}}</span><span>{{p.subType?.name}}</span></div>
            <div class="flex-row text-truncate">@for(d of p.detailsListCard; track $index; let isLast=$last){<span>{{d.value}} <span class="unit">{{d.label}}</span> @if(!isLast){ <span class="mx-1">|</span> }</span>}</div>
          </div>
          
          @if (isProperty(p) && p.auction?.auctionIsLive) {
            <div class="flex-col justify-left">
              <div>
                @if(isAuction || isMakeOfferBuyNow){
                  @if (!p.auction.hasBids) { <span class="auction-type">Opening Bid</span> } @else { <span class="auction-type">Current Bid </span> }
                  <div class="flex-row space-between">
                    <div class="price">{{p.auction.currentDisplayPrice | currency : 'USD' : 'symbol' : '1.2-2'}} </div>
                    <div class="green-color reserve-met" [style.visibility]="(isAuction && p.auction.reserveMet) ? 'visible' : 'hidden'">Reserve Met</div>
                  </div>
                }
                @else if(isCallForOffer){ 
                  <span class="auction-type">Call For Offers</span>
                  <div class="text-bold">
                    Offers Due By:
                  </div>
                }
                @else if(isRegularSale){
                  <span class="auction-type">Listing Price</span>
                  <div class="flex-row space-between">
                    <div class="price">{{p.auction.startPrice | currency : 'USD' : 'symbol' : '1.2-2'}} </div>
                  </div>
                }
              </div>
              @if(isAuction || isCallForOffer){
                <div class="flex-row mb-2">
                    <app-countdown-timer [targetDateTime]="p.auction.auctionEndingUnix" [compact]="true" ></app-countdown-timer>
                </div>
              }
              @else{
                <div class="primary-color text-bold text-lg">
                  Submit Offer
                </div>
              }
            </div>
          }
          @if (isProperty(p) && isAuction && p.auction?.auctionEnded) {
            <div>
              <span >Final price</span>: {{p.auction.currentDisplayPrice | currency : 'USD' : 'symbol' : '1.2-2'}}
            </div>
          }
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</div>
